import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // ✅ We will remove this after verifying styles work via Tailwind

const FormPhoneInput = ({
  label,
  name,
  value,
  onChange,
  register,
  error,
  required = false,
  className = "",
  defaultCountry = "ke",
  ...rest
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-[#636363] mb-1">
          {label}{required && <span className="text-red-500">*</span>}
        </label>
      )}

      <PhoneInput
        inputProps={{
          name,
          required,
          id: name,
          placeholder: "0700 123 456"
        }}
        country={defaultCountry}
        value={value}
        onChange={onChange}
        enableSearch={false}
        containerClass="!w-full"
        inputClass="!w-full !h-10 !rounded-md !border !border-[#CACACA] !bg-[#F6F6F6] !pl-16 !pr-4 !py-2 !text-sm !text-[#1100EF] placeholder:text-[#858585] focus:!text-black focus:!outline-none focus:!ring-2 focus:!ring-blue-500"
        buttonClass="!bg-[#F6F6F6] !pl-2 !pr-2 !border-r !border-[#CACACA]"
        {...rest}
      />

      {error && <p className="text-sm text-red-500 mt-1">{error.message}</p>}
    </div>
  );
};

export default FormPhoneInput;
